import { type FC, type HTMLAttributes, type ReactNode } from 'react'

import './index.scss'

export interface BodySemiBoldTextProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode
  className?: string
}

export const BodySemiBoldText: FC<BodySemiBoldTextProps> = ({ children, className = '', ...rest }) => (
  <p className={`body-semi-bold-text ${className}`} {...rest}>
    {children}
  </p>
)
